module.exports = __webpack_public_path__ + "img/Weekdays.8280986f.svg";